import {
    OBTENER_GRUPOS,
    AGREGAR_GRUPO,
    ELIMINAR_GRUPO,
    ACTUALIZAR_GRUPO,
    GRUPO_ERROR,
    GRUPO_OK,
    GRUPO_ACTUAL,
    OBTENER_GRUPO,
    MI_ORGANIZACION
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_GRUPOS:
            return {
                ...state,
                grupos: action.payload
            }
        case GRUPO_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case GRUPO_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_GRUPO:
            return {
                ...state,
                grupos: [...state.grupos, action.payload],
                nuevoGrupo:[action.payload], 
                formulario: false,
                errorformulario: false
            }
        case GRUPO_ACTUAL:
            return {
                ...state,
                grupo: state.grupos.find(grupo => grupo._id === action.payload)
            }
        case ELIMINAR_GRUPO:
            return {
                ...state,
                grupos: state.grupos.filter(grupo => grupo._id !== action.payload),
                grupo: null
            }
        case ACTUALIZAR_GRUPO:
            return {
                ...state,
                grupos: state.grupos.map(grupo => grupo._id === action.payload._id ? action.payload : grupo),
                grupo: action.payload
            }
        case OBTENER_GRUPO:
            return {
                ...state,
                grupo: action.payload
            }
        case MI_ORGANIZACION: 
            return {
                ...state,
                miOrganizacion: action.payload
            }
        default:
            return state;
    }
}